import React, { useState } from "react";
import PreLoaderWidget from '../../../components/Loader';
import IconEdit from '../../../assets/svg/ic-contact-edit.svg';
import IconRemove from '../../../assets/svg/ic-actions-trash.svg';
import moment from 'moment';
import CadastrarAuditoria from "../CadastrarAuditoria";
import ModalComponent from "../../../components/Modal";
import ComentarAuditoria from "../ComentarAuditoria";
import { AuditoriaStatus } from "../../../helpers/enums";
import { Row, Col } from 'reactstrap';
import { Link } from "react-router-dom";

const ContAuditoria = ({ auditorias, preloadAuditoria, getAuditoriasData, openMDLCAD }) => {
  const [auditoriaComment, setAuditoriaComment] = useState(false);
  const [auditoriaEdit, setAuditoriaEdit] = useState(false);
  const [auditoriaData, setAuditoriaData] = useState(null);

  return (
    <React.Fragment>
      <ModalComponent
        openModal={auditoriaComment}
        closeModal={() => setAuditoriaComment(false)}
        style={{ zIndex: 99999 }}
        modalSecundario={true}
      >
        <ComentarAuditoria
          auditoria={auditoriaData}
          getAuditoriasData={getAuditoriasData}
          onClose={() => {
            setAuditoriaComment(false)
            getAuditoriasData()
          }}
        />
      </ModalComponent>

      <ModalComponent
        openModal={auditoriaEdit}
        closeModal={() => setAuditoriaEdit(false)}
        style={{ zIndex: 99999 }}
        modalSecundario={true}
      >
        <CadastrarAuditoria
          idPaciente={auditoriaData && auditoriaData.ref.parent.parent.id}
          auditoria={auditoriaData}
          editing={true}
          onClose={() => {
            setAuditoriaEdit(false)
            getAuditoriasData()
          }}
        />
      </ModalComponent>

      <div className="p-2">
        <Row>
          <Col md={8}>
            <h1>Auditoria de Materiais</h1>
          </Col>
          <Col md={4}>
            <Link
              to="#"
              className="btn gb-button"
              style={{ maxWidth: "100px" }}
              onClick={openMDLCAD}
            >
              <i className="fa fa-plus mr-1" />Nova Auditoria
            </Link>
          </Col>
        </Row>
        <div className="gb-divider"><div className="line"></div></div>
        {preloadAuditoria ? (<div className="text-center" style={{ textAlign: 'center' }}><center>
          <PreLoaderWidget ></PreLoaderWidget>
          carregando...
        </center></div>) :
          auditorias && auditorias.length > 0 ?
            <div className="table-responsive pl-3 table-hover" style={{ paddingLeft: 5 }}>
              <table className="table table-hover gb-table" style={{ fontSize: '12px' }}>
                <thead>
                  <tr>
                    <th scope="col">Data</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Status</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {auditorias.sort((a, b) => { return moment(b.created_at) > moment(a.created_at) ? 1 : -1 }).map(
                    (item, index) => {
                      return (
                        <tr key={index} >
                          <td style={{ textAlign: 'center' }}>
                            {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
                          </td>
                          <td className='text-center'>{item.tipoMaterial}</td>
                          <td className='text-center' style={{
                            color: item.status === AuditoriaStatus.Aguardando ? "red"
                              : item.status === AuditoriaStatus.Comentado ? "orange" : "green"
                          }}>{item.status}</td>
                          <td className='text-center'>
                            <div className="d-flex justify-content-around">

                              <i className="fas fa-comment"
                                onClick={() => {
                                  setAuditoriaComment(true)
                                  setAuditoriaData(item)
                                }}
                                style={{ fontSize: 18, cursor: 'pointer' }} />

                              {item.status === AuditoriaStatus.Aguardando &&
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => {
                                    setAuditoriaEdit(true)
                                    setAuditoriaData(item)
                                  }
                                  }
                                >
                                  <img src={IconEdit} />
                                </a>
                              }

                              {/* <a
                                href="javascript:void(0)"
                                onClick={() =>
                                  console.log(item)
                                }
                                className="linkDelete"
                              >
                                <img src={IconRemove} />
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
            : <div className="text-center" style={{ textAlign: 'center' }}><center><p>Sem auditorias</p></center></div>
        }

      </div>
    </React.Fragment>
  )
}

export default ContAuditoria;